import { httpDelete, httpGet, httpPost } from './api.service';
import { SingleResult } from '../types/SingleResult';

const getValidScopes = async (): Promise<SingleResult<string[]>> => await httpGet(`api/scope/options`);

const searchScopeValues = async (scopeName: string, wildcard: string): Promise<SingleResult<ScopeValue[]>> => {
  return await httpGet<SingleResult<ScopeValue[]>>(`api/scope/${scopeName}/${wildcard}`);
};

const getScopeValuesForUser = async (appUserId: string, scopeName: string): Promise<SingleResult<ScopeValue[]>> => {
  return await httpGet<SingleResult<ScopeValue[]>>(`api/user/${appUserId}/scope/${scopeName}`);
};

const addValueToUserScope = async (appUserId: string, scopeName: string, value: string): Promise<SingleResult<ScopeValue[]>> => {
  return await httpPost<SingleResult<ScopeValue[]>>(`api/user/${appUserId}/scope/${scopeName}/${value}`);
};

const removeValueFromUserScope = async (appUserId: string, scopeName: string, value: string): Promise<SingleResult<ScopeValue[]>> => {
  return await httpDelete<SingleResult<ScopeValue[]>>(`api/user/${appUserId}/scope/${scopeName}/${value}`);
};

const getScopeValuesForTemplate = async (templateId: string, scopeName: string): Promise<SingleResult<ScopeValue[]>> => {
  return await httpGet<SingleResult<any>>(`api/scope/template/${templateId}/${scopeName}`);
};

const addValueToTemplateScope = async (templateId: string, scopeName: string, value: string): Promise<SingleResult<ScopeValue[]>> => {
  return await httpPost<SingleResult<ScopeValue[]>>(`api/scope/template/${templateId}/${scopeName}/${value}`);
};

const removeValueFromTemplateScope = async (templateId: string, scopeName: string, value: string): Promise<SingleResult<ScopeValue[]>> => {
  return await httpDelete<SingleResult<ScopeValue[]>>(`api/scope/template/${templateId}/${scopeName}/${value}`);
};

export {
  addValueToUserScope,
  addValueToTemplateScope,
  getScopeValuesForUser,
  getScopeValuesForTemplate,
  getValidScopes,
  removeValueFromUserScope,
  removeValueFromTemplateScope,
  searchScopeValues,
};
